<template>
  <div class="about">
    <h1>Get A Free Quote!</h1>
    <form @submit.prevent=checkForm>
      <div v-if="errors.length" class="formErrors">
        <b>Please correct the following error(s):</b>
        <ul>
          <li class="errorItem" v-bind:key=error v-for="error in errors">{{ error }}</li>
        </ul>
      </div>
      <div class="formRow">
        <div class="labelRow">
          <span class="label" title="Who is requesting this proposal?">Name:</span>
        </div>
        <div class="inputRow">
          <input type="text" v-model="model.name" name="Name" required="true" title="Please fill out this field" placeholder="Enter Name" />
        </div>
      </div>
      <div class="formRow">
        <div class="labelRow">
          <span class="label" title="Where will the installation occur?">Address:</span>
        </div>
        <div class="inputRow">
          <input type="text" v-model="model.address" name="Address" required="true" title="Please fill out this field" placeholder="Enter Address" />
        </div>
      </div>
      <div class="formRow">
        <div class="labelRow">
          <span class="label" title="Where will the installation occur?">City:</span>
        </div>
        <div class="inputRow">
          <input type="text" v-model="model.city" name="City" required="true" title="Please fill out this field" placeholder="Enter City" />
        </div>
      </div>
      <div class="formRow">
        <div class="labelRow">
          <span class="label" title="Where will the installation occur?">State:</span>
        </div>
        <div class="inputRow">
          <input type="text" v-model="model.state" name="State" required="true" title="Please fill out this field" placeholder="Enter State" />
        </div>
      </div>
      <div class="formRow">
        <div class="labelRow">
          <span class="label" title="Where will the installation occur?">Zip Code:</span>
        </div>
        <div class="inputRow">
          <input type="text" v-model="model.zipcode" name="Zipcode" required="true" title="Please fill out this field" placeholder="Enter Zip Code" />
        </div>
      </div>
      <div class="formRow">
        <div class="labelRow">
          <span class="label" title="What is the best number to reach you?">Phone:</span>
        </div>
        <div class="inputRow">
          <input type="phone" v-model="model.phone" name="Phone" required="true" title="Please fill out this field" placeholder="Enter Phone" />
        </div>
      </div>
      <div class="formRow">
        <div class="labelRow">
          <span class="label" title="Where should we send the proposal?">Email:</span>
        </div>
        <div class="inputRow">
          <input type="email" v-model="model.email" name="Email" required="true" title="Please fill out this field" placeholder="Enter Email" />
        </div>
      </div>
      <div class="formRow">    
        <div class="labelRow">
          <span class="label" title="How much square footage does the vacuum system need to cover?">Sq Ft:</span>
        </div>
        <div class="inputRow">
          <input type="number" v-model="model.sqft" required="true" title="Please fill out this field" placeholder="Enter Square Footage" />
        </div>
      </div>
      <div class="formRow">
        <!--Installation type-->
        <div class="radioGroupLabel">
          <span class="label">Installation Type:</span>
        </div>
        <div class="radioGroup">
          <input type="radio" id="new" value="New" title="New Home Install" v-model="model.installationType">
          <label for="new">New Home</label>
          <br>
          <input type="radio" id="existing" value="Existing" title="Existing Home Install" v-model="model.installationType">
          <label for="existing">Existing Home</label>
        </div>
      </div>
      <div class="formRow">
        <!--Other options-->
        <div class="radioGroupLabel">
          <span class="label">Other Options:</span>
        </div>
        <div class="radioGroup">
          <input type="checkbox" id="hah" value="Hide-A-Hose" v-model="model.otherOptions">
          <label for="hah">Hide-A-Hose</label><br>
          <input type="checkbox" id="vp" value="VacPan" v-model="model.otherOptions">
          <label for="vp">VacPan</label><br>
          <input type="checkbox" id="vr" value="Vroom" v-model="model.otherOptions">
          <label for="vr">Vroom</label><br>
          <input type="checkbox" id="sp" value="Spot" v-model="model.otherOptions">
          <label for="sp">Spot</label><br>
          <input type="checkbox" id="electro" value="ElectroValve" v-model="model.otherOptions">
          <label for="electro">Electrovalves</label><br>
        </div>
      </div>
      <div class="formRow" v-if="submitted">
        <p class="success">You will recieve a proposal within 1-2 business days. Please contact us if you do not hear from a team member within that time frame.
        </p>
      </div>
      <div class="formRow" v-if="!submitted">
        <div class="submitRow">
        <input
          type="submit"
          value="Submit"
          class="submitButton"
        >
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import store from '../store';

export default {
  data() {
    return {
      errors: [],
      model: {
        name: null,
        address: null,
        city: null,
        state: null,
        zipcode: null,
        phone: null,
        email: null,
        sqft: null,
        installationType: "New",
        otherOptions: [],
      },
      submitted: false,
    }
  },
  methods: {
    checkForm: function (e) {
      this.errors = [];

      if (!this.model.name) {
        this.errors.push("Name required.");
      }
      if (!this.model.email) {
        this.errors.push('Email required.');
      } else if (!this.validEmail(this.model.email)) {
        this.errors.push('Valid email required.');
      }

      if (!this.errors.length) {
        this.requestQuote();
        return true;
      }

      e.preventDefault();
    },
    validEmail: function (email) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    requestQuote: function (e) {
      var self = this;
      Email.send({
        SecureToken: '476df387-2ea3-41b7-b78e-cd117d39ab43',//'b6b3d375-3e94-4d3f-bdac-62c5ad044e1f',
        To: 'mike@clearyvac.com',
        From: "clearyvac@gmail.com",
        Subject: `Request for Proposal - ${this.model.name} (${this.model.installationType})`,
        Body: `Name: ${this.model.name}<br>
        Address: <br>
        ${this.model.address}<br>
        ${this.model.city}, ${this.model.state} ${this.model.zipcode}<br>
        Phone: ${this.model.phone}<br>
        Email: ${this.model.email}<br>
        Square Feet: ${this.model.sqft}<br>
        Type: ${this.model.installationType} Home <br>
        Other Options: ${this.model.otherOptions.join(', ')}<br>
        `
      }).then((message) => {
        if (message !== "OK") {
          alert(message) 
        } else {
          self.submitted = true;
        }
      });

      console.log(this.model);
    }
  }

}
</script>
<style lang="scss">

  .about {
    padding: 20px;
  }

  .errorItem {
    list-style: none;
    color: red;
  }

  .success {
    max-width: 250px;
  }

  .formRow {
    display: flex;
    padding: 10px;
  }
  .labelRow {
    flex: 1 1 150px;
    text-align: left;
  }
  .inputRow {
    flex: 1 1 auto;
    border: 1px solid #ccc;
    border-radius: 3px;
    margin-left: 20px;
  }

  .submitRow {
    flex: 1 1 auto;
    padding: 10px;
  }

  .radioGroup {
    flex: 1 1 100%;
    border-radius: 3px;
    margin-left: 20px;

    input {
      margin-top: 4px;
      cursor: pointer;
    }
  }

  .radioGroupLabel {
    flex: 1 1 100%;
    text-align: left;
  }

  .submitButton {
    width: 100%;
    height: 100%;
    background-color: #0d47a1;
    color: #eee;
    border-radius: 5px;
  }

  input, textarea {
      float: left;
  }
</style>